import { render, staticRenderFns } from "./agentManage.vue?vue&type=template&id=72a15166&scoped=true"
import script from "./agentManage.vue?vue&type=script&lang=js"
export * from "./agentManage.vue?vue&type=script&lang=js"
import style0 from "./agentManage.vue?vue&type=style&index=0&id=72a15166&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a15166",
  null
  
)

export default component.exports